/* eslint-disable */
import createIcon from '../createIcon';

const IconFilterOutlined = createIcon({
  name: 'icon-filter-outlined',
  content: '<path d="M128 128l288.832 319.936L422.08 768l187.008 128V447.936L896 128H128zm356.224 579.456l-4.736-270.528-.384-20.928-13.888-16.448L256 192h512L560.64 399.552l-14.272 16.832V768l-62.144-60.544z"/>',
  width: 1024,
  height: 1024
});
export default IconFilterOutlined;
